<template>
  <tr>
    <td>
      {{ file.createdAt | short_date_format }}
    </td>
    <td>
      {{ file.OldFile.type }}
    </td>
    <td>
      <a class="btn btn-primary btn-sm" :href="'https://techcar-dev.s3.amazonaws.com/' + file.objectKey" target="_blank">
        <span class="fa fa-download fa-fw"></span> Download
      </a>
      </span>
    </td>
  </tr>
</template>

<script>
export default {
  name: 'AccountFileRow',
  props: {
    object: {
      type: Object
    },
    index: {
      type: Number
    }
  },
  computed: {
    file () {
      return {
        ...this.object
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/rows/AccountFile.vue